import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedIds: [],
};

const checkboxSlice = createSlice({
  name: "checkbox",
  initialState,
  reducers: {
    addId: (state, action) => {
      if (!state.selectedIds.includes(action.payload)) {
        state.selectedIds.push(action.payload);
      }
    },
    removeId: (state, action) => {
      state.selectedIds = state.selectedIds.filter(
        (id) => id !== action.payload
      );
    },
    resetIds: (state) => {
      state.selectedIds = [];
    },
    setDefaultIds: (state, action) => {
      // Merge with any existing selected IDs to avoid duplicates
      const mergedIds = Array.from(
        new Set([...state.selectedIds, ...action.payload])
      );
      state.selectedIds = mergedIds;
    },
  },
});

export const { addId, removeId, resetIds, setDefaultIds } =
  checkboxSlice.actions;
export default checkboxSlice.reducer;
